import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 페이지 전환 시 스크롤을 상단으로 이동시키는 컴포넌트
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 페이지 이동 시 스크롤 위치를 맨 위로 이동
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'smooth'로 설정하면 부드럽게 스크롤됨
    });
  }, [pathname]); // pathname이 변경될 때마다 실행 (페이지 이동 시)

  return null; // 이 컴포넌트는 UI를 렌더링하지 않음
};

export default ScrollToTop;